var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Echart',{attrs:{"options":_vm.options,"id":_vm.id,"height":"2.25rem","width":"2.91rem"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }